module.exports = __webpack_public_path__ + "img/son.f1144c8a.png";